module.exports = __webpack_public_path__ + "img/ais-target-heading-l.ae80ef59.svg";